import { BaseConsentStrategy } from './strategies/BaseConsentStrategy';
import { NativeConsentStrategy } from './strategies/NativeConsentStrategy';
import { WebConsentStrategy } from './strategies/WebConsentStrategy';
import { ConsentStrategyParams } from './strategies/IConsentStrategy';

/**
 * Factory for creating consent strategies
 * Demonstrates how to use BaseConsentStrategy for consistent onConsentUpdated behavior
 */
export class ConsentStrategyFactory {
  /**
   * Create appropriate consent strategy based on environment
   */
  static createStrategy(params: ConsentStrategyParams): BaseConsentStrategy {
    if (params.isNative) {
      return new NativeConsentStrategy(params);
    } else {
      return new WebConsentStrategy(params);
    }
  }

  /**
   * Get all available strategy types
   */
  static getAvailableStrategies(): string[] {
    return ['NativeConsentStrategy', 'WebConsentStrategy'];
  }
}
